import React, { useState, useEffect } from 'react';
import styles from './stageDetails.module.scss';
import { Badge, Button, Col, Form, Row } from 'react-bootstrap';
import { CustomButton } from '../../../../../shared/customButton';
import { CustomDropdown } from '../../../../../shared/customDropdown';
import { CustomTextField } from '../../../../../shared/customTextField';
import { CustomTextArea } from '../../../../../shared/customTextArea';
import makeAnimated from 'react-select/animated';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import Select from 'react-select';
import * as yup from 'yup';
import { Formik, FieldArray } from 'formik';
import { getAllReviewers } from '../../../../../../services/util/userManagement';
import CSSLoader from '../../../../../shared/cssLoader';
import { CustomSwitch } from '../../../../../shared/customSwitch';
import { EditorState, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Editor } from "react-draft-wysiwyg";
import { getQuizDetailsToPiplelineStages } from '../../../../../../services/util/quizTemplates';
import { getOneWayInterviewDetailsToPipelineStages } from '../../../../../../services/util/oneWayInterviewTemplates';
import { useParams, useNavigate } from 'react-router-dom';
import { CustomStarTextField } from '../../../../../shared/customStarTextField';
import { CustomTextEditor } from '../../../../../shared/customTextEditor';

const StageDetails = (props) => {
    
    let [stageType, setStageType] = useState(props.values.step_type_code);
    let [options, setOptions] = useState();
    let [quizTemplateOptions, setQuizTemplateOptions] = useState();
    let [cvReviewersDefaultValues, setCvReviewersDefaultValues] = useState([]);
    let [assessmentReviewersDefaultValues, setAssessmentReviewersDefaultValues] = useState();
    let [quizOptionsDefaultValues, setquizOptionsDefaultValues] = useState([]);
    let [isLoading, setIsLoading] = useState(false);
    let [error, setError] = useState(false);
    let [onewayInterviewTemplateOptions, setOneWayInterviewTemplateOptions] = useState();
    let [onewayInterviewOptionsDefaultValues, setonewayInterviewOptionsDefaultValues] = useState([]);

    let contentState = '';
    let [assessment_body_html_value, set_assessment_body_html_value] = useState(props.values.assessment ? props.values.assessment : props.values.type_specific_parameters.assessment);
    let [quizTemplateLinkData, setquizTemplateLinkData] = useState('');
    let [onewayInterviewTemplateLinkData, setonewayInterviewTemplateLinkData] = useState('');

    let [referenceCheckReviewersDefaultValues, setReferenceCheckReviewersDefaultValues] = useState();
    let [customEvaluationReviewersDefaultValues, setCustomEvaluationReviewersDefaultValues] = useState();
    let [oneWayInterviewReviewersDefaultValues, setOneWayInterviewReviewersDefaultValues] = useState();
    let [isRefernceEmailAutoSend, setRefernceEmailAutoSend] = useState(props.values.type_specific_parameters.is_auto_request_referee_details_from_candidate_enabled);

    const history = useNavigate();



    const [reviewerCount, setReviewerCount] = useState([
        {
            label: '1',
            value: 1,
        },
        {
            label: '2',
            value: 2,
        },
        {
            label: '3',
            value: 3,
        },
    ])

    const reviewerCountOne = [
        {
            label: '1',
            value: 1,
        }
    ]

    const reviewerCountTwo = [
        {
            label: '1',
            value: 1,
        },
        {
            label: '2',
            value: 2,
        }
    ]

    const reviewerCountThree = [
        {
            label: '1',
            value: 1,
        },
        {
            label: '2',
            value: 2,
        },
        {
            label: '3',
            value: 3,
        },
    ]

    const animatedComponents = makeAnimated();
    let optionVlaues = [];
    let quizListValues = [];
    let onewayInterviewListValues = [];

    const dropValue = [
        {
            label: stageType === "InterviewStep" ? 'Interview' : stageType === "CvReviewStep" ? 'CV Review' : stageType === "ExternalAssessmentStep" ? 'External Assignment' : stageType === "AutomatedCVFilterStep" ? 'Auto CV Filter' : stageType === "QuizStep" ? 'Quiz Step' : stageType === "ReferenceCheckStep" ? 'Reference Check' : stageType === "CustomEvaluationStep" ? 'Custom Evaluation' : stageType === "OneWayInterviewStep" ? 'One Way Interview' : null,
            value: stageType === "InterviewStep" ? 2 : stageType === "CvReviewStep" ? 1 : stageType === "ExternalAssessmentStep" ? 3 : stageType === "AutomatedCVFilterStep" ? 4 : stageType === "QuizStep" ? 5 : stageType === "ReferenceCheckStep" ? 6 : stageType === "CustomEvaluationStep" ? 7 : stageType === "OneWayInterviewStep" ? 8 : null,
        }
    ]


    if (assessment_body_html_value) {
        const blocksFromHtml = htmlToDraft(assessment_body_html_value && assessment_body_html_value);
        const { contentBlocks, entityMap } = blocksFromHtml;
        contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    }

    const [editorState, setEditorState] = useState(
        assessment_body_html_value ?
            EditorState.createWithContent(contentState)
            :
            () => EditorState.createEmpty()
    );

    //review Criteria add and delete
    const addReviewCriteria = (e, values, setValues) => {

        const reviewCriteria = [...values.reviewCriteria];

        let newReviewCriteria = {
            label: ''
        }

        reviewCriteria.push(newReviewCriteria);
        setValues({ ...values, reviewCriteria });

    }

    const removeAddiionalReviewCriteria = (e, id, values, setValues) => {
        const reviewCriteria = [...values.reviewCriteria];
        if (reviewCriteria.length !== 0) {
            let newArray = reviewCriteria.filter(function (obj, index) {
                return index !== id;
            });
            setValues({ ...values, reviewCriteria: newArray });
        }
    }

    //yup validations
    const schema = yup.object({
        stageName: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required'),
        stageType: yup.string().required('Required'),
        numReviewer: yup.string().when('stageType', { is: 2, then: () => yup.string().required('Required'), otherwise: ()=> yup.string() }),

        score: yup.number().when('stageType', { is: (value) => ['1','2', '3', '5', '7', '8'].includes(value), then: () => yup.number().min(1).max(100).required('Required').test('is-decimal', 'Decimal point numbers are not allowed', (value) => /^\d+$/.test(value)),otherwise: () => yup.number() }),

        reviewers: yup.array().of(yup.object().shape({
            label: yup.string(),
            value: yup.string()
        })).when('stageType', { is: (value) => ['1'].includes(value), then:()=> yup.array().required('Required'), otherwise: ()=> yup.array()}),

        keywords: yup.array().of(yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^')).when('stageType', { is: (value) => ['10'].includes(value), then: ()=> yup.array().min(1, 'At least one keyword required. Enter the keyword and click "Add" button.').required(''),otherwise: () => yup.array() }),

        keywordToBeAdded: yup.string().when('stageType', { is: (value) => ['4'].includes(value), then: ()=> yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').test('duplicate keyword check', 'Duplicate keyword', function (item) { return !this.parent.keywords.includes(item); }) ,otherwise: () => yup.string()}),

        keywordCount: yup.number().when('stageType', { is: (value) => ['4'].includes(value), then: ()=> yup.number().test('keyword check', 'Keywords count cannot be greater than added keyword count', function (item) { return this.parent.keywords.length >= item; }).min(1, 'Should be greater than 1').required('Required'), otherwise: () => yup.number() }),

        assessment_body: yup.string().when('stageType', { is: (value) => ['3'].includes(value), then: () => yup.string().required('Required').test('email body check', 'Required', function (item) { let stripedHtml = item.replace(/<[^>]+>/g, ''); return stripedHtml.length > 0; }),  otherwise: () => yup.string()}),

        assessment_expire_in: yup.number().when('stageType', { is: (value) => ['3'].includes(value), then: () => yup.number().required('Required').integer('Invalid input').moreThan(0, 'Invalid input'), otherwise: () => yup.number()}),

        quiz_expire_in: yup.number().when('stageType', { is: (value) => ['5'].includes(value), then: () => yup.number().required('Required').moreThan(0, 'Invalid input').test('is-decimal', 'Decimal point numbers are not allowed', (value) => /^\d+$/.test(value)),  otherwise: () => yup.number()}),

        quiz_template: yup.object().shape({
            label: yup.string(),
            value: yup.string()
        }).when('stageType', { is: (value) => ['5'].includes(value), then: ()=> yup.object().required('Required'), otherwise: ()=> yup.object().nullable()}),

        assessment_reviewers: yup.object().shape({
            label: yup.string(),
            value: yup.string()
        }).when('stageType', { is: (value) => ['3'].includes(value), then: () =>yup.object().required('Required'), otherwise: ()=> yup.object().nullable() }),

        //Reference Check
        reference_check_reviewers: yup.object().typeError('Reviewers cannot be empty').when('stageType', {
            is: (value) => ['6'].includes(value), then: ()=> yup.object().shape({
                label: yup.string(),
                value: yup.string()
            }).required('Required').nullable(), otherwise: () => yup.object().nullable()
        }),

        min_no_of_references_required: yup.number().when('stageType', { is: (value) => ['6'].includes(value), then: () => yup.number().min(2).max(4).required('Required').test('is-decimal', 'Decimal point numbers are not allowed', (value) => /^\d+$/.test(value)),otherwise: () => yup.number() }),
       
        //Custom Evaluation
        custom_evaluation_reviewers: yup.object().typeError('Reviewers cannot be empty').when('stageType', {
            is: (value) => ['7'].includes(value), then: () =>yup.object().shape({
                label: yup.string(),
                value: yup.string()
            }).required('Required').nullable(), otherwise: ()=> yup.object().nullable()
        }),
        vacancyDesc: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^'),
        guide_for_candidates: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^'),
        guidelineDescription: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').nullable(),
        //Custom Evaluation Description
        evaluationDescription: yup.string().when('stageType', {
            is: (value) => ['7'].includes(value), then: ()=> yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required').nullable(), otherwise: ()=> yup.string()
        }),
        //One-Way Interview Reviewers
        one_way_interview_reviewers: yup.object().typeError('Reviewers cannot be empty').when('stageType', {
            is: (value) => ['8'].includes(value), then: ()=> yup.object().shape({
                label: yup.string(),
                value: yup.string()
            }).required('Required').nullable(), otherwise: ()=> yup.object().nullable()
        }),
        expire_in: yup.number().typeError('Only numbers allowed').when('stageType', {
            is: (value) => ['8'].includes(value),
            then: ()=> yup.number().required('Required').integer('Invalid input').moreThan(0, 'Invalid input')
        }),
        one_way_interview_template: yup.object().typeError('one way interview template cannot be empty').when('stageType', {
            is: (value) => ['8'].includes(value), then: ()=> yup.object().shape({
                label: yup.string(),
                value: yup.string()
            }).required('Required').nullable(), otherwise: ()=> yup.object().nullable()
        }),
        reviewCriteria: yup.array().when('stageType', {
            is: (value) => ['1','2','3','7','8'].includes(value), 
            then: () => yup.array().of(
                yup.object().shape({
                    label: yup.string()
                        .matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^')
                        .required('Required') 
                })
            )
            .unique('Duplicate review criterion', r => r.label) 
            .min(1, 'At least one review criterion is required. Click "Add New Criteria".')
            .required('Required')
        })
 });

    //on submit function
    const onSubmit = async (values) => {

        if (values.stageType === 1) { //CV Review
            if (values.numReviewer <= values.reviewers.length) {
                props.updateCVReviewValues(values)
                props.nextPage(2)
            } else {
                setError(true)
            }
        } else if (values.stageType === 2) { //Interview
            props.updateInterviewValues(values)
            props.nextPage(2)
        } else if (values.stageType === 3) { //External Assessment
            props.updateExternalAssessmentStepValues(values)
            props.nextPage(2)
        } else if (values.stageType === 4) { //CV Filter
            props.updateCVFilterValues(values)
            props.nextPage(2)
        } else if (values.stageType === 5) { //Quiz
            props.updateQuizstepValues(values)
            props.nextPage(2)
        } else if (values.stageType === 6) { //Reference Check
            props.updateReferenceCheckStepValues(values)
            props.nextPage(2)
        } else if (values.stageType === 7) { //Custom Evaluation
            props.updateCustomEvaluationStepValues(values)
            props.nextPage(2)
        } else if (values.stageType === 8) { //One Way Interview
            props.updateOneWayInterviewStepValues(values)
            props.nextPage(2)
        }
    }


    useEffect(() => {
        if (props.values.step_type_code == 'OneWayInterviewStep' ) {
            setOneWayInterviewDetails();
        }else if(props.values.step_type_code == 'QuizStep'){
            setQuizDetails();
        }
        
    }, [props.values]);

   
    async function setQuizDetails() {
        setIsLoading(true)

        let quizListValues = [];

        let quizList = await getQuizDetailsToPiplelineStages();
        await (quizList.data).forEach(element => {
            quizListValues.push({ label: element.name, value: element.quiz_template_id })
        });
        await setQuizTemplateOptions(quizListValues);

        if (props.values.step_type_code == 'QuizStep') {
            setIsLoading(true);
            let default_quiz_obj;

            if (props.values.type_specific_parameters.quiz_template.template_id) {
                default_quiz_obj = {
                    label: props.values.type_specific_parameters.quiz_template.template_name,
                    value: props.values.type_specific_parameters.quiz_template.template_id
                }
            } else {
                default_quiz_obj = {
                    label: props.values.type_specific_parameters.quiz_template.label,
                    value: props.values.type_specific_parameters.quiz_template.value
                }
            }

            await setquizOptionsDefaultValues(default_quiz_obj);
            setquizTemplateLinkData(default_quiz_obj);
            if (quizOptionsDefaultValues.length > 0) {
                setIsLoading(false);
            }else{
                setIsLoading(true);
            }
        }
        setIsLoading(false);   
    }

    async function setOneWayInterviewDetails() {
        setIsLoading(true)
        let onewayInterviewListValues = [];

        let onewayInterviewList = await getOneWayInterviewDetailsToPipelineStages();
        await (onewayInterviewList.data).forEach(element => {
            onewayInterviewListValues.push({ label: element.template_name, value: element.one_way_interview_template_id })
        });
        await setOneWayInterviewTemplateOptions(onewayInterviewListValues);

        if (onewayInterviewTemplateOptions) {
            setIsLoading(true);
        }

        if (props.values.step_type_code == 'OneWayInterviewStep') {
            setIsLoading(true);
            let default_one_way_interview_obj;

            if (props.values.type_specific_parameters.one_way_interview_template.template_id) {
                default_one_way_interview_obj = {
                    label: props.values.type_specific_parameters.one_way_interview_template.template_name,
                    value: props.values.type_specific_parameters.one_way_interview_template.template_id
                }
            } else {
                default_one_way_interview_obj = {
                    label: props.values.type_specific_parameters.one_way_interview_template.label,
                    value: props.values.type_specific_parameters.one_way_interview_template.value
                }
            }

            await setonewayInterviewOptionsDefaultValues(default_one_way_interview_obj);
            setonewayInterviewTemplateLinkData(default_one_way_interview_obj);
            if (onewayInterviewOptionsDefaultValues.length > 0) {
                setIsLoading(false);
            }
            else{
                setIsLoading(true);
            }
        }
        setIsLoading(false);   
    }
    async function setReviwers() {
        setIsLoading(true);
        let optionValues = [];
    
        try {
            let reviewersList = await getAllReviewers();
            reviewersList.data.forEach(element => {
                optionValues.push({
                    label: element.user_id.email + ' - ' + element.user_id.first_name + ' ' + element.user_id.last_name,
                    value: element._id
                });
            });
            setOptions(optionValues);
        } catch (error) {
            console.error("Failed to fetch reviewers:", error);
        } finally {
            setIsLoading(false);
        }
    }
    
    useEffect(() => {
        
        setReviwers()
        if (props.values.step_type_code == 'ExternalAssessmentStep') {

            let defaultOptionValues = {
                label: props.values.type_specific_parameters.assessment_reviewers.label,
                value: props.values.type_specific_parameters.assessment_reviewers.value
            }

            setAssessmentReviewersDefaultValues(defaultOptionValues)
        }
        if (props.values.step_type_code == 'CvReviewStep') {
            let defaultOptionValues = [];

            (props.values.type_specific_parameters.reviewers).forEach(element => {
                defaultOptionValues.push({ label: element.label, value: element.value })
            });
            setCvReviewersDefaultValues(defaultOptionValues);
        }
        
        if (props.values.step_type_code == 'ReferenceCheckStep') {

            let defaultOptionValues = {
                label: props.values.type_specific_parameters.reference_check_reviewers.label,
                value: props.values.type_specific_parameters.reference_check_reviewers.value
            }

            setReferenceCheckReviewersDefaultValues(defaultOptionValues)
        }
        if (props.values.step_type_code == 'CustomEvaluationStep') {

            let defaultOptionValues = {
                label: props.values.type_specific_parameters.custom_evaluation_reviewers.label,
                value: props.values.type_specific_parameters.custom_evaluation_reviewers.value
            }

            setCustomEvaluationReviewersDefaultValues(defaultOptionValues)
        }
        if (props.values.step_type_code == 'OneWayInterviewStep') {

            let defaultOptionValues = {
                label: props.values.type_specific_parameters.one_way_interview_reviewers.label,
                value: props.values.type_specific_parameters.one_way_interview_reviewers.value
            }

            setOneWayInterviewReviewersDefaultValues(defaultOptionValues)
        }
        
    }, [props.values.step_type_code]);

    const removeTextDecoration = (htmlContent) => {
        let noDecoration = htmlContent.replace(/<span style="text-decoration: (underline|line-through|overline);[^>]*>(.*?)<\/span>/gi, '$2');
        noDecoration = noDecoration.replace(/<span style="background-color: [^;]+;[^>]*>(.*?)<\/span>/gi, '$1');
        noDecoration = noDecoration.replace(/<span style="color: [^;]+;[^>]*>(.*?)<\/span>/gi, '$1');
        let withFont = noDecoration.replace(/(<span[^>]*>)(<\/span>)/gi, (match, opening, closing) => {
            if (opening) {
                return opening + ' style="font-family: Inter, sans-serif; font-size: 12px;"';
            } else {
                return closing;
            }
        });
        // Set font family and size to Inter, sans-serif; font-size: 16px for <h3> tags
        withFont = withFont.replace(/<h3[^>]*>(.*?)<\/h3>/gi, (match, content) => {
            return `<h3 style="font-family: Inter, sans-serif; font-size: 16px !important;">${content}</h3>`;
        });
        
        return withFont;
    };

    return (
        <div>
            {
                isLoading === false ?

                    <Formik
                        validationSchema={schema}
                        onSubmit={(values) => onSubmit(values)}
                        initialValues={{ 
                            stageName: props.values.step_name,
                            score: props.values.type_specific_parameters.minimum_pass_score,
                            vacancyDesc: props.values.type_specific_parameters.evaluation_criteria,
                            stageType: dropValue[0].value,
                            numReviewer: props.values.step_type_code == 'CvReviewStep' ? props.values.type_specific_parameters.number_of_reviewers_per_cv : '',
                            reviewers: cvReviewersDefaultValues, assessment_reviewers: assessmentReviewersDefaultValues,
                            keywords: props.values.keywords, keywordToBeAdded: props.values.keywordToBeAdded,
                            keywordCount: props.values.keywordCount,
                            guidelineDescription: props.values.type_specific_parameters.interview_guidelines_to_candidate,
                            assessment_body: assessment_body_html_value,
                            assessment_expire_in: props.values.type_specific_parameters.assessment_expire_in,
                            quiz_template: props.values.step_type_code == 'QuizStep' ? quizOptionsDefaultValues : '',
                            quiz_expire_in: props.values.type_specific_parameters.quiz_expire_in,
                            reference_check_reviewers: referenceCheckReviewersDefaultValues,
                            min_no_of_references_required: props.values.type_specific_parameters.min_no_of_references_required,
                            guide_for_candidates: props.values.type_specific_parameters.guide_for_candidates,
                            custom_evaluation_reviewers: customEvaluationReviewersDefaultValues,
                            evaluationDescription: props.values.type_specific_parameters.custom_evaluation_description,
                            one_way_interview_reviewers: oneWayInterviewReviewersDefaultValues,expire_in: props.values.type_specific_parameters.expire_in,
                            one_way_interview_template: props.values.step_type_code == 'OneWayInterviewStep' ?  onewayInterviewOptionsDefaultValues: '',
                            reviewCriteria: props.values.type_specific_parameters.review_criteria,
                                           
                        }}>                                

                        {({
                            values,
                            errors,
                            setFieldValue,
                            handleChange,
                            handleSubmit,
                            submitCount,
                            setValues,
                        }) => (
                            <Form noValidate onSubmit={handleSubmit}>


                                <CustomTextField
                                    label="Stage Name"
                                    name="stageName"
                                    classLabel="defaultLabel"
                                    controlId="stageName"
                                    placeholder="ex:- Technical CV Review Step"
                                    type="text"
                                    disabled={true}
                                    value={values.stageName}
                                    classType="defaultTextBox"
                                    handleOnChange={handleChange}
                                    errorMessage={errors.stageName}
                                    isInvalid={submitCount > 0 && !!errors.stageName}
                                />

                                <CustomDropdown
                                    label="Stage Type"
                                    controlId="stageType"
                                    name="stageType"
                                    disabled={true}
                                    dropdownValues={dropValue}
                                    value={values.stageType}
                                    errorMessage={errors.stageType}
                                    isInvalid={submitCount > 0 && !!errors.stageType}
                                />
                                {(stageType === "CvReviewStep") &&
                                    <div>

                                        <Form.Label className={styles.defaultLabel}>
                                            Reviewers &nbsp;
                                            <svg data-tooltip-id={`reviewersList`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                            <ReactTooltip id={`reviewersList`} place="right" type="dark" effect="solid" clickable={true}>
                                                <div className={styles.toolTipBox}>{stageType === "CvReviewStep" ? <p>During the evaluation, candidate CVs will be automatically and randomly distributed among the selected reviewers.</p> : stageType === "ExternalAssessmentStep" ? <p>During the evaluation, candidate Assignment will be automatically distributed among the selected reviewers.</p> : null}</div>
                                            </ReactTooltip>
                                        </Form.Label>

                                        <Select
                                            className={styles.selctText}
                                            defaultValue={values.reviewers}
                                            options={options}
                                            isMulti={true}
                                            components={animatedComponents}
                                            name="reviewers"
                                            class="react-select__control"
                                            onChange={(e) => {
                                                setFieldValue('reviewers', e);
                                                props.setNumReviewers(e ? e.length : 0);
                                            }}
                                            styles={
                                                errors.reviewers === 'Required' ?
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                            border: '1px solid #dc3545', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                    }
                                                    :
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                            border: '1px solid #bdbdbd', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                        multiValue: (styles) => {
                                                            return {
                                                                ...styles,
                                                                background: 'rgba(45, 166, 192, 0.1)',
                                                            };
                                                        },
                                                        multiValueLabel: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                        }),
                                                        multiValueRemove: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                            ':hover': {
                                                                backgroundColor: '#24859A',
                                                                color: 'white',
                                                            },
                                                        }),
                                                    }
                                            }
                                        />
                                        <p className={styles.errorMsg}>{errors.reviewers}</p>

                                    </div>
                                }
                                {(stageType === "ExternalAssessmentStep") &&
                                    <div>

                                        <Form.Label className={styles.defaultLabel}>
                                            Reviewer &nbsp;
                                            <svg data-tooltip-id={`reviewersList`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                            <ReactTooltip id={`reviewersList`} place="right" type="dark" effect="solid" clickable={true}>
                                                <div className={styles.toolTipBox}>{stageType === "CvReviewStep" ? <p>During the evaluation, candidate CVs will be automatically assigned to the selected reviewer.</p> : stageType === "ExternalAssessmentStep" ? <p>During the evaluation, candidate Assignment will be automatically distributed among the selected reviewers.</p> : null}</div>
                                            </ReactTooltip>
                                        </Form.Label>
                                        <Select
                                            className={styles.selctText}
                                            defaultValue={values.assessment_reviewers}
                                            options={options}
                                            components={animatedComponents}
                                            name="assessment_reviewers"
                                            class="react-select__control"
                                            onChange={(e) => { setFieldValue('assessment_reviewers', e); }}
                                            styles={
                                                errors.assessment_reviewers === 'Required' ?
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                            border: '1px solid #dc3545', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                    }
                                                    :
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                            border: '1px solid #bdbdbd', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                        multiValue: (styles) => {
                                                            return {
                                                                ...styles,
                                                                background: 'rgba(45, 166, 192, 0.1)',
                                                            };
                                                        },
                                                        multiValueLabel: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                        }),
                                                        multiValueRemove: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                            ':hover': {
                                                                backgroundColor: '#24859A',
                                                                color: 'white',
                                                            },
                                                        }),
                                                    }
                                            }
                                        />
                                        <p className={styles.errorMsg}>{errors.assessment_reviewers}</p>

                                    </div>
                                }

                                {(stageType === "ReferenceCheckStep") &&
                                    <div>

                                        <Form.Label className={styles.defaultLabel}>
                                            Reviewer &nbsp;
                                            <svg data-tooltip-id={`reviewersList`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                            <ReactTooltip id={`reviewersList`} place="right" type="dark" effect="solid" clickable={true}>
                                                <div className={styles.toolTipBox}>{stageType === "CvReviewStep" ? <p>During the evaluation, candidate CVs will be automatically assigned to the selected reviewer.</p> : stageType === "ExternalAssessmentStep" ? <p>During the evaluation, candidate Assignment will be automatically distributed among the selected reviewers.</p> : stageType === "ReferenceCheckStep" ? <p>During the evaluation, candidate profile will be automatically distributed among the selected reviewer to check references.</p> : null}</div>
                                            </ReactTooltip>
                                        </Form.Label>
                                        <Select
                                            className={styles.selctText}
                                            defaultValue={values.reference_check_reviewers}
                                            options={options}
                                            components={animatedComponents}
                                            name="reference_check_reviewers"
                                            class="react-select__control"
                                            onChange={(e) => { setFieldValue('reference_check_reviewers', e); }}
                                            styles={
                                                errors.reference_check_reviewers === 'Required' ?
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                            border: '1px solid #dc3545', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                    }
                                                    :
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                            border: '1px solid #bdbdbd', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                        multiValue: (styles) => {
                                                            return {
                                                                ...styles,
                                                                background: 'rgba(45, 166, 192, 0.1)',
                                                            };
                                                        },
                                                        multiValueLabel: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                        }),
                                                        multiValueRemove: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                            ':hover': {
                                                                backgroundColor: '#24859A',
                                                                color: 'white',
                                                            },
                                                        }),
                                                    }
                                            }
                                        />
                                        <p className={styles.errorMsg}>{errors.reference_check_reviewers}</p>

                                    </div>
                                }

                                {(stageType === "CustomEvaluationStep") &&
                                    <div>

                                        <Form.Label className={styles.defaultLabel}>
                                            Reviewer &nbsp;
                                            <svg data-tooltip-id={`reviewersList`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                            <ReactTooltip id={`reviewersList`} place="right" type="dark" effect="solid" clickable={true}>
                                                <div className={styles.toolTipBox}>{stageType === "CvReviewStep" ? <p>During the evaluation, candidate CVs will be automatically assigned to the selected reviewer.</p> : stageType === "ExternalAssessmentStep" ? <p>During the evaluation, candidate Assignment will be automatically distributed among the selected reviewers.</p> : stageType === "ReferenceCheckStep" ? <p>During the evaluation, candidate profile will be automatically distributed among the selected reviewer to check references.</p> : stageType === "CustomEvaluationStep" ? <p>During the evaluation, candidate Assignment will be automatically distributed among the selected reviewers.</p> : null}</div>
                                            </ReactTooltip>
                                        </Form.Label>
                                        <Select
                                            className={styles.selctText}
                                            defaultValue={values.custom_evaluation_reviewers}
                                            options={options}
                                            components={animatedComponents}
                                            name="custom_evaluation_reviewers"
                                            class="react-select__control"
                                            onChange={(e) => { setFieldValue('custom_evaluation_reviewers', e); }}
                                            styles={
                                                errors.custom_evaluation_reviewers === 'Required' ?
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                            border: '1px solid #dc3545', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                    }
                                                    :
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                            border: '1px solid #bdbdbd', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                        multiValue: (styles) => {
                                                            return {
                                                                ...styles,
                                                                background: 'rgba(45, 166, 192, 0.1)',
                                                            };
                                                        },
                                                        multiValueLabel: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                        }),
                                                        multiValueRemove: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                            ':hover': {
                                                                backgroundColor: '#24859A',
                                                                color: 'white',
                                                            },
                                                        }),
                                                    }
                                            }
                                        />
                                        <p className={styles.errorMsg}>{errors.custom_evaluation_reviewers}</p>

                                    </div>
                                }

                                {(stageType === "OneWayInterviewStep" && values.one_way_interview_template) &&
                                    <div>
                                        <Form.Label className={styles.defaultLabel}>
                                            Select Interview Template&nbsp;
                                            <svg data-tooltip-id={`reviewersListInterviewTemplate`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                            <ReactTooltip id={`reviewersListInterviewTemplate`} place="right" type="dark" effect="solid" clickable={true}>
                                                <div className={styles.toolTipBox}>{<p>During the evaluation, candidates will be assigned to answer the questions in the selected template.</p>}</div>
                                            </ReactTooltip>
                                        </Form.Label>

                                        <p className={styles.reviewersNotice}>If you don't see any options here, go to "<span className={styles.documentLink} onClick={() => { history(`/company/templates/one-way-interview-templates`) }}  ><span className={styles.quizTemplateLink}>Interview Templates</span>
                                        </span>" and create one way interview templates and activate them.</p>
                                        <Select
                                            className={styles.selctText}
                                            defaultValue={values.one_way_interview_template}
                                            options={onewayInterviewTemplateOptions}
                                            name="one_way_interview_template"
                                            class="react-select__control"
                                            components={animatedComponents}

                                            onChange={(e) => { setFieldValue('one_way_interview_template', e); setonewayInterviewTemplateLinkData(e) }}
                                            //props.setNumReviewers(e && e.length)
                                            // getOptionValue={option => `${option.one_way_interview_template_id}`}
                                            // getOptionLabel={option => `${option.template_name} `}
                                            styles={
                                                errors.reviewers === 'Required' ?
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                            border: '1px solid #dc3545', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                    }
                                                    :
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                            border: '1px solid #bdbdbd', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                        multiValue: (styles) => {
                                                            return {
                                                                ...styles,
                                                                background: 'rgba(45, 166, 192, 0.1)',
                                                            };
                                                        },
                                                        multiValueLabel: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                        }),
                                                        multiValueRemove: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                            ':hover': {
                                                                backgroundColor: '#24859A',
                                                                color: 'white',
                                                            },
                                                        }),
                                                    }
                                            }
                                        />
                                        <p className={styles.errorMsg}>{errors.reviewers}</p>

                                    </div>

                                }

                                {(stageType === "OneWayInterviewStep") &&
                                    <div>

                                        <Form.Label className={styles.defaultLabel}>
                                            Reviewer &nbsp;
                                            <svg data-tooltip-id={`reviewersList`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                            <ReactTooltip id={`reviewersList`} place="right" type="dark" effect="solid" clickable={true}>
                                                <div className={styles.toolTipBox}>{stageType === "CvReviewStep" ? <p>During the evaluation, candidate CVs will be automatically assigned to the selected reviewer.</p> : stageType === "ExternalAssessmentStep" ? <p>During the evaluation, candidate Assignment will be automatically distributed among the selected reviewers.</p> : stageType === "ReferenceCheckStep" ? <p>During the evaluation, candidate profile will be automatically distributed among the selected reviewer to check references.</p> : stageType === "CustomEvaluationStep" ? <p>During the evaluation, candidate Assignment will be automatically distributed among the selected reviewers.</p> : stageType === "OneWayInterviewStep" ? <p>During the evaluation, candidate one way interviews will be automatically distributed among the selected reviewers.</p> : null}</div>
                                            </ReactTooltip>
                                        </Form.Label>
                                        <Select
                                            className={styles.selctText}
                                            defaultValue={values.one_way_interview_reviewers}
                                            options={options}
                                            components={animatedComponents}
                                            name="one_way_interview_reviewers"
                                            class="react-select__control"
                                            onChange={(e) => { setFieldValue('one_way_interview_reviewers', e); }}
                                            styles={
                                                errors.one_way_interview_reviewers === 'Required' ?
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                            border: '1px solid #dc3545', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                    }
                                                    :
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                            border: '1px solid #bdbdbd', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                        multiValue: (styles) => {
                                                            return {
                                                                ...styles,
                                                                background: 'rgba(45, 166, 192, 0.1)',
                                                            };
                                                        },
                                                        multiValueLabel: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                        }),
                                                        multiValueRemove: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                            ':hover': {
                                                                backgroundColor: '#24859A',
                                                                color: 'white',
                                                            },
                                                        }),
                                                    }
                                            }
                                        />
                                        <p className={styles.errorMsg}>{errors.custom_evaluation_reviewers}</p>

                                    </div>
                                }

                                {(stageType === "QuizStep" && values.quiz_template) &&
                                    <div>
                                        <Form.Label className={styles.defaultLabel}>
                                            Select Quiz &nbsp;
                                            <svg data-tooltip-id={`reviewersListQuiz`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                            <ReactTooltip id={`reviewersListQuiz`} place="right" type="dark" effect="solid" clickable={true}>
                                                <div className={styles.toolTipBox}>{<p>During the evaluation, candidates will get assigned answer the questions in the selected template.</p>}</div>
                                            </ReactTooltip>
                                        </Form.Label>

                                        <p className={styles.reviewersNotice}>If you don't see any options here, go to "<span className={styles.documentLink} onClick={() => { history(`/company/templates/quiz-templates`) }}  ><span className={styles.quizTemplateLink}>Quiz Templates</span>
                                        </span>" and create quiz templates and activate them.</p>
                                        <Select
                                            className={styles.selctText}
                                            defaultValue={values.quiz_template}
                                            options={quizTemplateOptions}
                                            name="quiz_template"
                                            class="react-select__control"
                                            components={animatedComponents}

                                            onChange={(e) => { setFieldValue('quiz_template', e); setquizTemplateLinkData(e) }}
                                            //props.setNumReviewers(e && e.length)
                                            // getOptionValue={option => `${option.quiz_template_id}`}
                                            // getOptionLabel={quizTemplateOptions => `${quizTemplateOptions.label} `}
                                            styles={
                                                errors.reviewers === 'Required' ?
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#dc3545' }, // border style on hover
                                                            border: '1px solid #dc3545', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                    }
                                                    :
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                            border: '1px solid #bdbdbd', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                        multiValue: (styles) => {
                                                            return {
                                                                ...styles,
                                                                background: 'rgba(45, 166, 192, 0.1)',
                                                            };
                                                        },
                                                        multiValueLabel: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                        }),
                                                        multiValueRemove: (styles) => ({
                                                            ...styles,
                                                            color: '#24859A',
                                                            ':hover': {
                                                                backgroundColor: '#24859A',
                                                                color: 'white',
                                                            },
                                                        }),
                                                    }
                                            }
                                        />
                                        <p className={styles.errorMsg}>{errors.reviewers}</p>

                                    </div>

                                }

                                {/* {stageType === "QuizStep" &&
                                    <div>
                                        {quizTemplateLinkData ?
                                            <p className={styles.documentLink} onClick={() => { history(`/company/quiz-templates/${quizTemplateLinkData.value}`) }}  >  <span className={styles.quizTemplateLink}>Check the Quiz Details  <span className={styles.focuedDocumentLinkText}>{quizTemplateLinkData.label}</span> Stages <i class="fas fa-external-link-alt"></i></span>
                                            </p>
                                            :
                                            <p className={styles.documentLink} >  <span className={styles.quizTemplateLink}>Please select a  <span className={styles.focuedDocumentLinkText}>Quiz</span> to Proceed </span>
                                            </p>
                                        }
                                    </div>
                                } */}

                                {stageType === "CvReviewStep" &&
                                    <div>

                                        <CustomDropdown
                                            label="Number of Reviewers Per CV"
                                            labelToolTip="How many reviewers should be assigned to evaluate one candidate CV."
                                            labelToolTipId="numOfReviewersPerCV"
                                            controlId="adminPanel_hiringPipeline_editPipeline_editStagesModal_stageDetails_noOfReviewersPerCvEditModeId"
                                            name="numReviewer"
                                            value={values.numReviewer}
                                            handleOnChange={(e) => { setFieldValue('numReviewer', parseInt(e.target.value)) }}
                                            dropdownValues={props.noOfReviewers === 3 ? reviewerCountThree : reviewerCountTwo}
                                            errorMessage={errors.numReviewer}
                                            isInvalid={submitCount > 0 && !!errors.numReviewer}
                                            classType={
                                                error === true ?
                                                    "defaultErrorDropDown"
                                                    : "defaultDropDown"
                                            }
                                        />
                                        {
                                            error === true ?
                                                (<p className={styles.errorMsg} id="adminPanel_hiringPipeline_editPipeline_editStagesModal_stageDetails_noOfReviewersPerCv_validationMsgId">Number Of Reviewers Per CV Cannot Larger than Selected Reviewers</p>)
                                                : null

                                        }
                                    </div>
                                }
                                
                                {(stageType === "ReferenceCheckStep") &&                               
                                    <CustomTextField
                                        label="Minimum Number of References"
                                        labelToolTip="Number of reference candidates needed to be added."
                                        labelToolTipId="min_no_of_references_required"
                                        name="min_no_of_references_required"
                                        placeholder="ex:- 2"
                                        classLabel="defaultLabel"
                                        controlId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_minimunNumberOfReferencesEditModeId"
                                        type="number"
                                        value={values.min_no_of_references_required}
                                        classType="defaultTextBox"
                                        handleOnChange={handleChange}
                                        errorMessage={errors.min_no_of_references_required}
                                        isInvalid={submitCount > 0 && !!errors.min_no_of_references_required}
                                    />
                                    
                                }
                                {(stageType === "ReferenceCheckStep") &&
                                    <div className={styles.autoEmailTogle}>
                                        <p className={styles.defaultLabel}>Request referee details automatically&nbsp;</p>
                                        <span className='ms-3 mt-0 d-flex  align-items-center'>
                                            <CustomSwitch
                                                classType={isRefernceEmailAutoSend ? "animateSwitchActive" : "animateSwitch"}
                                                handleChange={(e) => { setFieldValue('is_auto_request_referee_details_from_candidate_enabled', !isRefernceEmailAutoSend); setRefernceEmailAutoSend(!isRefernceEmailAutoSend); }}
                                                isChecked={isRefernceEmailAutoSend}
                                            />
                                        </span>
                                    </div>
                                }

                                {(stageType === "CvReviewStep" || stageType === "InterviewStep" || stageType === "ExternalAssessmentStep" || stageType === "QuizStep" || stageType === "ReferenceCheckStep" || stageType === "CustomEvaluationStep" || stageType === "OneWayInterviewStep") &&
                                    <div>
                                        {(stageType != "ReferenceCheckStep") &&
                                            <CustomTextField
                                                label="Minimum Pass Score"
                                                labelToolTip="The minimum score that candidates should receive in order to pass from this evaluation stage. Enter a percentage value."
                                                labelToolTipId="minimumPassScore"
                                                name="score"
                                                placeholder="ex:- 75"
                                                classLabel="defaultLabel"
                                                controlId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_minimumPassScoreEditModeFieldId"
                                                type="number"
                                                value={values.score}
                                                classType="defaultTextBox"
                                                handleOnChange={handleChange}
                                                errorMessage={errors.score}
                                                isInvalid={submitCount > 0 && !!errors.score}
                                            />
                                        }
                                        {(stageType != "QuizStep") &&
                                            <Form.Group controlId="exampleForm.ControlTextarea1">
                                                <Form.Label className={styles.textareaLabel}>
                                                    Guideline For Reviewers &nbsp;
                                                    <svg data-tooltip-id={`reviewersCriteria`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                                    <ReactTooltip id={`reviewersCriteria`} place="right" type="dark" effect="solid" clickable={true}>
                                                        <div className={styles.toolTipBox}>{stageType === 'CvReviewStep' ? <p> A guideline for reviewers to evaluate candidate CVs.</p> : stageType === 'ReferenceCheckStep' ? <p> A guideline for reviewers to evaluate candidate references.</p> : stageType === 'CustomEvaluationStep' ? <p> A guideline for reviewers to evaluate candidate custom evaluations</p> : <p>A guideline for interviewers to evaluate candidates.</p>}</div>
                                                    </ReactTooltip>
                                                </Form.Label>
                                                {/* <Form.Control as="textarea" name="vacancyDesc" value={values.vacancyDesc} onChange={handleChange} rows={3} className={styles.textareaBox} placeholder={stageType === 'CvReviewStep' ? "Ex: Review candidate CVs based on technical skills. Ideal candidates should have knowledge on reactjs, nodejs, mongodb , mysql, aws, java, html." : "Ex: Evaluate candidates based on technical skills. Ideal candidates should have knowledge on reactjs, nodejs, mongodb , mysql, aws, java, html."} /> */}
                                                <CustomTextArea
                                                    name="vacancyDesc"
                                                    controlId="adminPanel_hiringPipeline_editPipeline_addStagesModal_stageDetailsConfiguration_guidelineForReviewersTextAreaEditModeID"
                                                    values={values.vacancyDesc}
                                                    errorMessage={errors.vacancyDesc}
                                                    handleChange={handleChange}
                                                    isInvalid={submitCount > 0 && !!errors.vacancyDesc}
                                                    remainingCount={(values.vacancyDesc).length}
                                                    placeholder={stageType === 'CvReviewStep' ? "Ex: Review candidate CVs based on technical skills. Ideal candidates should have knowledge on reactjs, nodejs, mongodb , mysql, aws, java, html." : stageType === 'ReferenceCheckStep' ? "Ex: Evaluate candidates based on references." : stageType === 'CustomEvaluationStep' ? "Ex: Evaluate candidates based on custom evaluations." : "Ex: Evaluate candidates based on technical skills. Ideal candidates should have knowledge on reactjs, nodejs, mongodb , mysql, aws, java, html."}
                                                // maxLength={800}
                                                />
                                            </Form.Group>
                                        }

                                    </div>
                                }

                                {(stageType === "ReferenceCheckStep") &&
                                    <Form.Group controlId="exampleForm.ControlTextarea1">
                                        <Form.Label className={styles.textareaLabel}>
                                            Guideline For Candidates &nbsp;
                                            <svg data-tooltip-id={`guide_for_candidates`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                            <ReactTooltip id={`guide_for_candidates`} place="right" type="dark" effect="solid" clickable={true}>
                                                <div className={styles.toolTipBox}>{<p>Guidelines for candidates to submit references.</p>}</div>
                                            </ReactTooltip>
                                        </Form.Label>

                                        <CustomTextArea
                                            name="guide_for_candidates"
                                            values={values.guide_for_candidates}
                                            errorMessage={errors.guide_for_candidates}
                                            handleChange={handleChange}
                                            isInvalid={submitCount > 0 && !!errors.guide_for_candidates}
                                            placeholder="Ex: Please provide the contact details of your previous employer."
                                        />
                                    </Form.Group>
                                }

                                {(stageType === "InterviewStep") &&
                                    <div>
                                        <Form.Group controlId="exampleForm.ControlTextarea1">
                                            <Form.Label className={styles.textareaLabel}>
                                                Interview Guidelines&nbsp;For&nbsp;Candidates&nbsp;
                                                <svg data-tooltip-id={`interviewGuideline`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                                <ReactTooltip id={`interviewGuideline`} place="right" type="dark" effect="solid" clickable={true}>
                                                    <div className={styles.toolTipBox}>{<p> A guideline for candidates to prepare for the interview.</p>}</div>
                                                </ReactTooltip>

                                            </Form.Label>

                                            {/* <Form.Control as="textarea" name="guidelineDescription" value={values.guidelineDescription} onChange={handleChange} rows={3} className={styles.textareaBox} placeholder={"Ex: This is a technical interview so get ready for technical questions."} /> */}
                                            <CustomTextArea
                                                name="guidelineDescription"
                                                controlId="adminPanel_hiringPipeline_editPipeline_editStagesModal_stageDetails_interviewGuidelineForCandidatesTextAreaId"
                                                values={values.guidelineDescription}
                                                errorMessage={errors.guidelineDescription}
                                                handleChange={handleChange}
                                                isInvalid={submitCount > 0 && !!errors.guidelineDescription}
                                                placeholder={"Ex: This is a technical interview so get ready for technical questions."}
                                            // remainingCount={(values.guidelineDescription).length}
                                            // maxLength={800}
                                            />
                                        </Form.Group>
                                    </div>
                                }
                                {(stageType === "CustomEvaluationStep") &&
                                    <div>
                                        <Form.Group controlId="exampleForm.ControlTextarea1">
                                            <Form.Label className={styles.textareaLabel}>
                                                Custom Evaluation Description&nbsp;For&nbsp;Reviewers&nbsp;
                                                <svg data-tooltip-id={`evaluationDescription`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                                <ReactTooltip id={`evaluationDescription`} place="right" type="dark" effect="solid" clickable={true}>
                                                    <div className={styles.toolTipBox}>{<p> A guideline for reviewer to how to conduct the Custom Evaluation.</p>}</div>
                                                </ReactTooltip>

                                            </Form.Label>

                                            <CustomTextArea
                                                name="evaluationDescription"
                                                values={values.evaluationDescription}
                                                controlId="adminPanel_hiringPipeline_editPipeline_editStagesModal_stageDetails_cusomEvaluationDescriptionTextAreaId"
                                                errorMessage={errors.evaluationDescription}
                                                handleChange={handleChange}
                                                isInvalid={submitCount > 0 && !!errors.evaluationDescription}
                                            />
                                        </Form.Group>
                                    </div>
                                }
                                {(stageType === "AutomatedCVFilterStep") &&
                                    <div>
                                        <Form.Group className={styles.formText} controlId="adminPanel_hiringPipeline_editPipeline_editStagesModal_stageDetails_keywordToScanFieldId">
                                            <Form.Label
                                                className={styles.defaultLabel}>
                                                Keywords to Scan&nbsp;&nbsp;
                                                <svg data-tooltip-id={`KeyWordToScanInfo`} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#17a2b8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                                <ReactTooltip id={`KeyWordToScanInfo`} place="right" type="dark" effect="solid" clickable={true}>
                                                    <div className={styles.toolTipBox}>{<p> Add keywords one by one.</p>}</div>
                                                </ReactTooltip>
                                            </Form.Label>
                                            <p className={styles.reviewersNotice}>As a best practice choose common keywords. Such as "<b>java</b>", "<b>technical writing</b>", "<b>digital marketing</b>". Do not use uncommon multiword keywords, otherwise most of the CVs will get rejected automatically.</p>
                                            <div className={styles.keywordInputFormDiv}>
                                                <Form.Control
                                                    className={styles.defaultTextBox}
                                                    name="keywordToBeAdded"
                                                    type="text"
                                                    placeholder='Java'
                                                    value={values.keywordToBeAdded || ''}
                                                    onChange={(e) => { setFieldValue('keywordToBeAdded', e.target.value.toLowerCase()) }}
                                                    isInvalid={submitCount > 0 && !!errors.keywordToBeAdded}
                                                    errorMessage={errors.keywordToBeAdded}
                                                />
                                                <Button type="button" variant="primary" className={styles.keywordAddBtn} id="adminPanel_hiringPipeline_editPipeline_editStagesModal_stageDetails_keywordAddBtnId" disabled={!!errors.keywordToBeAdded} onClick={((values.keywordToBeAdded).length > 0) ? () => { values.keywords.push(values.keywordToBeAdded.toLowerCase()); setFieldValue('keywordToBeAdded', ''); } : null}>Add</Button>
                                            </div>
                                            {errors.keywordToBeAdded &&
                                                <span className={styles.errorMsg}>{errors.keywordToBeAdded}</span>
                                            }
                                            {submitCount > 0 && errors.keywords && !errors.keywordToBeAdded &&
                                                <span className={styles.errorMsg}>{errors.keywords}</span>
                                            }

                                            <Row xs="auto" className="mt-2 mb-4">
                                                {
                                                    values.keywords.map((item, i) => (
                                                        (
                                                            <Col  className="ms-0 me-0 mt-2">
                                                            <div className={styles.keywordbadgeDiv} key={i}>
                                                                    <Badge bg="light" className={styles.keywordbadge} id={`adminPanel_hiringPipeline_editPipeline_editStagesModal_stageDetails_addedKeywordEditmodeId.${i}`}>{item}&nbsp;&nbsp;
                                                                    <span onClick={() => { values.keywords.splice(i, 1); setFieldValue('keywords', values.keywords) }}>
                                                                        <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M10.5 3.5L3.5 10.5" stroke="#24859A" strokeLinecap="round" strokeLinejoin="round" />
                                                                            <path d="M3.5 3.5L10.5 10.5" stroke="#24859A" strokeLinecap="round" strokeLinejoin="round" />
                                                                        </svg>
                                                                    </span>
                                                                </Badge>
                                                            </div>
                                                            </Col>
                                                        )
                                                    ))
                                                }
                                            </Row>
                                        </Form.Group>

                                        <CustomTextField
                                            label="Minimum required keyword count"
                                            name="keywordCount"
                                            placeholder="ex:- 5"
                                            classLabel="defaultLabel"
                                            controlId="adminPanel_hiringPipeline_editPipeline_editStagesModal_stageDetails_minimumRequiredKeywordCountEditModeId"
                                            type="number"
                                            value={values.keywordCount}
                                            classType="defaultTextBox"
                                            handleOnChange={handleChange}
                                            errorMessage={errors.keywordCount}
                                            isInvalid={submitCount > 0 && !!errors.keywordCount}
                                        />
                                    </div>
                                }
                                {(stageType === "ExternalAssessmentStep") &&
                                    <div>
                                        <div>
                                            <Form.Group>
                                                <div className='mt-3'>
                                                    <Form.Label className={styles.defaultLabel}>
                                                        Assignment
                                                    </Form.Label>
                                                </div>
                                                <div className={submitCount > 0 && errors.assessment_body ? styles.emailBodyContainerError : styles.emailBodyContainer}>
                                                <CustomTextEditor
                                                value = {assessment_body_html_value}
                                                handleOnChange={(e) => {
                                                    set_assessment_body_html_value(e);
                                                    setFieldValue('assessment_body', removeTextDecoration(e));
                                                }} 
                                                />
                                                </div>
                                                {submitCount > 0 && errors.assessment_body &&
                                                    <div>
                                                        <span className={styles.errorMessage}>
                                                            {errors.assessment_body}
                                                        </span>
                                                    </div>
                                                }

                                            </Form.Group>
                                            <Form.Group>
                                                <div  className='mt-3'>
                                                    <p className={styles.defaultLabel}>Assignment Expire After </p>
                                                </div>

                                                <div >
                                                    <Row className={styles.toggleContainer}>
                                                        <Col>

                                                            <CustomTextField
                                                                //label="Short Description about Review Criteria"
                                                                //labelToolTip="The minimum score that candidates should receive in order to pass from this evaluation stage. Enter a percentage value."
                                                                //labelToolTipId="minimumPassScore"
                                                                name="assessment_expire_in"
                                                                placeholder="ex:- 5"
                                                                classLabel="defaultLabel"
                                                                controlId="adminPanel_hiringPipeline_editPipeline_editStagesModal_stageDetails_assesmentExpireAfterFieldId"
                                                                type="number"
                                                                value={values.assessment_expire_in}
                                                                classType="defaultTextBox"
                                                                handleOnChange={handleChange}
                                                                errorMessage={errors.assessment_expire_in}
                                                                isInvalid={submitCount > 0 && !!errors.assessment_expire_in}
                                                            />



                                                        </Col>
                                                        <Col lg={1} className='mt-2 mr-3'>

                                                            <p className={styles.daysLabel}>days</p>


                                                        </Col>
                                                    </Row>


                                                </div>
                                            </Form.Group>

                                        </div>
                                    </div>
                                }
                                {(stageType === "QuizStep") &&
                                    <div>
                                        <Form.Group>
                                            <div>
                                                <p className={styles.defaultLabel}>Quiz Expire After </p>
                                            </div>

                                            <div >
                                                <Row className={styles.toggleContainer}>
                                                    <Col>

                                                        <CustomTextField
                                                            //label="Short Description about Review Criteria"
                                                            //labelToolTip="The minimum score that candidates should receive in order to pass from this evaluation stage. Enter a percentage value."
                                                            //labelToolTipId="minimumPassScore"
                                                            name="quiz_expire_in"
                                                            placeholder="ex:- 5"
                                                            classLabel="defaultLabel"
                                                            controlId="adminPanel_hiringPipeline_editPipeline_editStagesModal_stageDetails_quizExpireAfterFieldId"
                                                            type="number"
                                                            value={values.quiz_expire_in}
                                                            classType="defaultTextBox"
                                                            handleOnChange={handleChange}
                                                            errorMessage={errors.quiz_expire_in}
                                                        />



                                                    </Col>
                                                    <Col lg={1} className='mt-2 mr-3'>

                                                        <p className={styles.daysLabel}>days</p>


                                                    </Col>
                                                </Row>

                                                <p className={styles.errorMsg}>{errors.quiz_expire_in}</p>
                                            </div>
                                        </Form.Group>

                                    </div>

                                }
                                {(stageType === "OneWayInterviewStep") &&
                                    <div>
                                        <Form.Group>
                                            <div  className='mt-3'>
                                                <p className={styles.defaultLabel}>Interview Expire After </p>
                                            </div>

                                            <div >
                                                <Row className={styles.toggleContainer}>
                                                    <Col>

                                                        <CustomTextField
                                                            name="expire_in"
                                                            placeholder="ex:- 5"
                                                            classLabel="defaultLabel"
                                                            controlId="expire_in"
                                                            type="number"
                                                            value={values.expire_in}
                                                            classType="defaultTextBox"
                                                            handleOnChange={handleChange}
                                                            errorMessage={errors.expire_in}
                                                            isInvalid={submitCount > 0 && !!errors.expire_in}
                                                        />

                                                    </Col>
                                                    <Col lg={1} className='mt-2 mr-3'>

                                                        <p className={styles.daysLabel}>days</p>


                                                    </Col>
                                                </Row>                                                                                             
                                            </div>
                                        </Form.Group>

                                    </div>

                                }
                                { (stageType === "OneWayInterviewStep" || stageType === "ExternalAssessmentStep" || stageType === "CustomEvaluationStep" || stageType === "CvReviewStep" || stageType === "InterviewStep") &&
                                    <div className={styles.responsibilitiesDiv}>
                                    <p className={styles.defaultLabel}>Evaluation criteria for candidates</p>
                                    <p className={styles.reviewCriteriaErrorMsg}>{(errors && errors.reviewCriteria && !Array.isArray(errors.reviewCriteria)) && errors.reviewCriteria}</p>
                                    <FieldArray name="reviewCriteria">
                                        {() => (values.reviewCriteria && values.reviewCriteria.map((reviewCriteria, i) => {


                                            const reviewCriteriaErrors = ((errors.reviewCriteria?.length) && (errors.reviewCriteria[i])) || {};
                                            return (
                                                <div key={i}>
                                                    <CustomStarTextField
                                                        keyValue={i}
                                                        classLabel="defaultLabel"
                                                        controlId={`adminPanel_hiringPipeline_editPipeline_EditPipelineModal_reviewCriteriaFieldId.${i}`}
                                                        id={`adminPanel_hiringPipeline_editPipeline_EditPipelineModal_reviewCriteriaDeleteBtnId.${i}`}
                                                        type="text"
                                                        value={(values && values.reviewCriteria && values.reviewCriteria[i]) && values.reviewCriteria[i].label}
                                                        handleOnChange={handleChange}
                                                        name={`reviewCriteria.${i}.label`}
                                                        classType="defaultTextBox"
                                                        onCancelClick={(e) => removeAddiionalReviewCriteria(e, i, values, setValues)}
                                                        errorMessage={(errors && errors.reviewCriteria && errors.reviewCriteria[i]) && errors.reviewCriteria[i].label}
                                                        isInvalid={(errors && errors.reviewCriteria && errors.reviewCriteria[i]) ? true : false}
                                                        isCancelable={true}
                                                    />
                                                </div>
                                            );
                                        }))}
                                    </FieldArray>
                                    <CustomButton
                                        id="adminPanel_hiringPipeline_editPipeline_EditPipelineModal_addReviewCriteriaBtnId"
                                        buttonType="button"
                                        label="Add review Criteria"
                                        type="secondarySmallBtn"
                                        handleClick={(e) => addReviewCriteria(e, values, setValues)}
                                        frontIcon={
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                <path d="M10 4.66667V16.3333M4.16669 10.5H15.8334" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        }

                                    />

                                </div>
                                }
                                


                                <div className={styles.nexBtnDiv}>
                                    <CustomButton
                                        id="adminPanel_hiringPipeline_editPipeline_editStagesModal_stageDetails_reviewBtnId"
                                        buttonType="submit"
                                        label="Review"
                                        type="primaryBtn"
                                    />
                                </div>
                            </Form>
                        )}
                    </Formik>
                    :
                    (<div>
                        <Col sm={{ span: 4, offset: 4 }}>
                            <CSSLoader />
                        </Col>
                    </div>)
            }
        </div >
    )
}

export default StageDetails;
